export function isMobileDevice() {
  var isMobileDevice = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
  return isMobileDevice;
}

export function getThreatDrillKey(threat, isDrill) {
  return threat + "|" + (isDrill ? "true" : "false");
}

export function decodeThreatDrillKey(key) {
  const [threat, drill] = key.split("|");
  return [Number(threat), drill === "true" ? true : false];
}

export function getTitleFromThreartDrillKey(threat, isDrill) {
  const key = String(threat) + "|" + String(isDrill);
  return {
    "-1|false": "דוגמה בלבד [שם האיום]",
    "-1|true": "דוגמה בלבד [שם האיום]",

    "0|false": "צבע אדום",
    "0|true": "תרגיל צבע אדום",

    "1|false": "אירוע חומרים מסוכנים",
    "1|true": "תרגיל חומרים מסוכנים",

    "2|false": "חשש לחדירת מחבלים",
    "2|true": "תרגיל חדירת מחבלים",

    "3|false": "רעידת אדמה",
    "3|true": "תרגיל רעידת אדמה",

    "4|false": "חשש לצונאמי",
    "4|true": "תרגיל צונאמי",

    "5|false": "חדירת כלי טיס עוין",
    "5|true": "תרגיל חדירת כלי טיס",

    "6|false": "חשש לאירוע רדיולוגי",
    "6|true": "תרגיל אירוע רדיולוגי",

    "7|false": "ירי בלתי קונבנציונלי",
    "7|true": "תרגיל ירי לא קונבנציונלי",

    "8|false": "התרעה",
    "8|true": "תרגיל התרעה",

    "9|false": "תרגיל פיקוד העורף",
    "9|true": "תרגיל פיקוד העורף",
  }[key];
}

export function getColorForThreat(threat) {
  switch (threat) {
    case 0:
      return "#A52A2A";
    case 2:
      return "rgb(255, 213, 0)";
    case 3:
      return "rgb(0, 255, 85)";
    case 4:
      return "rgb(0, 128, 255)";
    case 5:
      return "rgb(255, 128, 0)";
    default:
      return "#A52A2A";
  }
}
